import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../dudigital.png';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'Coaches' },
  { to: '/reviews', label: 'Reviews' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
        <Link to="/" className="header__logo">
          <img src={logo} alt="RFR Pro" />
        </Link>

        <nav className="header__nav">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`header__nav-link${location.pathname === to ? ' active' : ''}`}
            >
              {label}
            </Link>
          ))}
          <Link to="/contact" className="header__cta">Book Now</Link>
        </nav>

        <button
          className={`header__burger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <div className={`drawer${menuOpen ? ' open' : ''}`}>
        <div className="drawer__inner">
          <div className="drawer__logo">
            <img src={logo} alt="RFR Pro" />
          </div>
          <nav className="drawer__nav">
            {navLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`drawer__link${location.pathname === to ? ' active' : ''}`}
              >
                {label}
              </Link>
            ))}
          </nav>
          <Link to="/contact" className="drawer__cta">Book a Session</Link>
        </div>
      </div>

      <div
        className={`backdrop${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(false)}
      />
    </>
  );
};

export default Header;
